export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "What areas does Diaz Brothers Construction serve?",
    a: "We're based in Highlands Ranch, CO and work across the Denver metro, the foothills, and Northern Colorado — including Littleton, Centennial, Lone Tree, Castle Pines, Parker, Ken Caryl, Morrison, Evergreen, Genesee, Conifer, Sedalia, Franktown, Larkspur, Elizabeth, Longmont, and Loveland.",
  },
  {
    q: "What services do you offer?",
    a: "Residential and commercial interior and exterior painting, facade and exterior surface waterproofing, complete and partial remodeling, drywall installation and repair, tile and ceramic installation, and comprehensive residential improvement services. If it involves surfaces, walls, or finishes, it's likely something we do.",
  },
  {
    q: "How much does a project cost?",
    a: "Every property is different, so we quote each job individually after seeing it. Estimates are free, written, and itemized so you can see exactly what you're paying for — no vague lump sums and no pressure to sign on the spot.",
  },
  {
    q: "Do you offer any discounts?",
    a: "Yes. New clients receive 15% off their first project with us. Existing customers earn a 10% discount when they refer a friend, neighbor, or family member who books a job.",
  },
  {
    q: "Do you speak Spanish? / ¿Hablan español?",
    a: "Yes — our team is fully bilingual in English and Spanish. Sí, nuestro equipo habla español e inglés. Llámenos y con gusto le atendemos en su idioma.",
  },
  {
    q: "What are your business hours?",
    a: "We're reachable Monday through Friday from 9:00 AM to 5:00 PM, with Saturday appointments available when a project calls for it. You can call (720) 586-3832 or text (915) 234-3558 any time and we'll get back to you.",
  },
  {
    q: "How long does a typical painting project take?",
    a: "A single interior room is usually one day. A full-home interior repaint typically runs three to five days, and a complete exterior repaint runs four to seven days depending on square footage, prep work, and Colorado weather. We give you a realistic schedule up front — not an optimistic one.",
  },
  {
    q: "Do you handle prep work and repairs, or just paint?",
    a: "Prep is the job. We patch drywall, replace rotted trim and siding, sand, caulk, and prime before a finish coat goes on. We also handle drywall, tile, and full remodeling — so if a wall needs repairing before it needs painting, the same crew does both.",
  },
  {
    q: "What is facade waterproofing and do I need it?",
    a: "It's a protective coating applied to stucco, masonry, block, or concrete that seals hairline cracks and porous surfaces so water can't get into the wall assembly. If you're seeing staining, efflorescence (white powdery deposits), spalling, or cracking on an exterior wall, waterproofing is far cheaper than the structural repair that follows if you wait.",
  },
  {
    q: "Do you work on commercial buildings?",
    a: "Yes. We paint and maintain commercial interiors and exteriors, apply waterproof coatings to commercial facades, and handle drywall and tile work for offices, retail spaces, and multi-unit properties. We schedule around your operating hours where possible.",
  },
];
